import { CardContent, CardHeader, Stack, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

import Icon from 'components/Icon'
import theme from 'theme'

export const WhatIsAService: React.FC = () => {
  return (
    <>
      <CardHeader
        title={
          <Typography variant="h6">
            What is a Service?{' '}
            <Link
              target="_blank"
              to={{
                pathname: 'https://www.gremlin.com/blog/what-is-a-service/'
              }}
            >
              <Icon
                css={{ fontSize: theme.fontSizes[2] }}
                icon="arrowUpRightFromSquare"
              />
            </Link>
          </Typography>
        }
      />
      <CardContent>
        <Stack>
          <Typography paragraph variant="body2">
            Services usually have 4 key characteristics:
          </Typography>
          <Stack direction="row" spacing={1}>
            <Typography variant="body2">1.</Typography>
            <Typography variant="body2">They are lightweight.</Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Typography variant="body2">2.</Typography>
            <Typography variant="body2">
              They have discrete and clearly defined boundaries.
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Typography variant="body2">3.</Typography>
            <Typography variant="body2">
              They are independently managed.
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Typography variant="body2">4.</Typography>
            <Typography variant="body2">They are easily scalable.</Typography>
          </Stack>
        </Stack>
      </CardContent>
    </>
  )
}
